import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p0003607-card-electrolyseur-controle',
  templateUrl: './p0003607-card-electrolyseur-controle.component.html',
  styleUrls: ['./p0003607-card-electrolyseur-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe],
})
export class P0003607CardElectrolyseurControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P0003606.dashboard.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P0003606.dashboard.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttonMode = [
      {
        id: 0,
        title: 'P0003607.dashboard.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        id: 3,
        title: 'P0003607.dashboard.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
      },
      {
        id: 2,
        title: 'P0003607.dashboard.regulation',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
      },
      {
        id: 1,
        title: 'P0003607.dashboard.horloge',
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.ELECTROLYSEUR_STANDARD,
      FunctionOnglet.PARAMETRE_REGLAGE,
      this.translateService.instant('P0003607.dashboard.electrolyseur'),
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
